
// no image options, 2 columns – filters out disabled items

window.addEventListener('load', function () {
  const DisplayTemplateA = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    computed: {
      visibleItems() {
        return this.items || [];
      }
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full" style="grid-template-columns: repeat(2, minmax(0, 1fr));">
          <button
            v-for="item in visibleItems"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            {{ item.label }}

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center transition-opacity duration-200 ease-in-out z-50"
            >
              ✓
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-a'] = DisplayTemplateA;
});

// b

window.addEventListener('load', function () {
  const DisplayTemplateB = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div>
        <p class="text-gray-600 text-base mb-4">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-3 md:!grid-cols-4">
          <button
            v-for="item in items"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="rounded relative cursor-pointer flex flex-col justify-start h-full transition-all duration-200"
            :style="{
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              backgroundColor: 'white',
              transform: selected === item.id ? 'scale(1.02)' : 'scale(1)',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img :src="item.thumbnail" alt="" class="w-full aspect-square object-cover" />
            <div class="text-center py-2 text-sm">{{ item.label }}</div>

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center z-50"
            >
              ✓
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-b'] = DisplayTemplateB;
});



// no image options, 3 columns

window.addEventListener('load', function () {
  const DisplayTemplateC = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2 md:!grid-cols-3">
          <button
            v-for="item in items"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold text-black transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            {{ item.label }}

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center transition-opacity duration-200 ease-in-out z-50"
            >
              ✓
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-c'] = DisplayTemplateC;
});




// fancy buttons image + description + price (styled like template E)

window.addEventListener('load', function () {
  const DisplayTemplateD = {
    props: {
      label: String,
      value: [String, Number],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectItem(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div v-if="items?.length">
          <div
            v-for="item in items"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectItem(item.id)"
            :disabled="item.disabled"
            class="cursor-pointer flex items-center rounded-lg p-4 transition relative mb-3"
            :style="{
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail"
              alt=""
              class="w-20 h-20 object-cover rounded mr-4"
            >
            <div class="flex-1">
              <div class="text-base font-semibold">{{ item.label }}</div>
              <div v-if="item.description" class="text-sm text-gray-500 leading-snug mt-1" v-html="item.description"></div>

            </div>
            <div v-if="item.price" class="text-lg font-semibold ml-4 whitespace-nowrap">
              € {{ item.price.toFixed(0) }}
            </div>

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center z-50"
            >
              ✓
            </div>
          </div>
        </div>
        <div v-else class="text-sm text-gray-400">No options available</div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-d'] = DisplayTemplateD;
});





// two-option toggle with styled card (No = items[0], Yes = items[1])

window.addEventListener('load', function () {
  const DisplayTemplateE = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: null,
        hovering: null
      };
    },
    methods: {
      updateSelection() {
        if (this.items.length > 0) {
          this.selected = this.value === this.items[1]?.id;
        }
      },
      toggleSelection() {
        if (!this.items[1]?.disabled) {
          this.selected = !this.selected;
        }
      }
    },
    template: `
      <div class="mb-6">
        <div v-if="items?.length > 1">
          <div
            @mouseenter="!items[1].disabled && (hovering = true)"
            @mouseleave="hovering = null"
            @click="toggleSelection"
            class="cursor-pointer flex items-center rounded-lg p-4 transition relative"
            :style="{
              border: selected
                ? '2px solid #69949b'
                : hovering && !items[1].disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              backgroundColor: selected ? '#F8F8FA' : 'white',
              opacity: items[1].disabled ? 0.4 : 1,
              cursor: items[1].disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img
              v-if="items[1].thumbnail"
              :src="items[1].thumbnail"
              alt=""
              class="w-20 h-20 object-cover rounded mr-4"
            >
            <div class="flex-1">
              <div class="text-base font-semibold">{{ label }}</div>
              <div v-if="items[1].description" class="text-sm text-gray-500 leading-snug mt-1" v-html="items[1].description"></div>

            </div>
            <div v-if="items[1].price" class="text-lg font-semibold ml-4 whitespace-nowrap">
              € {{ items[1].price.toFixed(0) }}
            </div>

            <div
              v-if="selected"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center z-50"
            >
              ✓
            </div>
          </div>
        </div>
        <div v-else class="text-sm text-gray-400">No options available</div>
      </div>
    `,
    watch: {
      value() {
        this.updateSelection();
      },
      selected(newValue) {
        if (newValue) {
          this.$emit('input', this.items[1].id); // Yes
        } else {
          this.$emit('input', this.items[0].id); // No
        }
      }
    },
    mounted() {
      this.updateSelection();
    }
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-e'] = DisplayTemplateE;
});


// deselectable pill-style options with fallback to "None" (items[0]), but "None" is hidden

window.addEventListener('load', function () {
  const DisplayTemplateF = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        if (newVal === null || newVal === undefined) {
          this.$emit('input', this.items[0]?.id); // Fallback to "None"
        } else {
          this.$emit('input', newVal);
        }
      }
    },
    methods: {
      toggleOption(id) {
        this.selected = this.selected === id ? null : id;
      }
    },
    template: `
      <div class="mb-6">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2 md:!grid-cols-3">
          <button
            v-for="item in items.slice(1)"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && toggleOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold text-black transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            {{ item.label }}

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center transition-opacity duration-200 ease-in-out z-50"
            >
              ✓
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-f'] = DisplayTemplateF;
});




// 3 columns with image

window.addEventListener('load', function () {
  const DisplayTemplateG = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2 md:!grid-cols-3">
          <button
            v-for="item in items"
            :key="item.id"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold transition-all duration-200 ease-in-out transform rounded cursor-pointer flex flex-col items-center"
            :style="{
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid #69949b'
                : hovering === item.id && !item.disabled
                  ? '2px solid #69949b'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail"
              alt=""
              style="width: 100%; height: auto; border-radius: 4px; margin-bottom: 0.5rem;"
            />
            <div class="text-center">{{ item.label }}</div>

            <div
              v-if="selected === item.id"
              class="absolute -top-3 -right-3 w-6 h-6 rounded-full checkmark bg-[#222] border-2 border-white text-white text-sm flex items-center justify-center z-50"
            >
              ✓
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-g'] = DisplayTemplateG;
});
